import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyMapKeys } from '@locales/lokalise/keyMap';

export interface IErrorViewModel {
  processing: boolean;
  errMsg: string | ForbiddenException;
}

export interface ForbiddenException {
  type: string;
  errorMessage: string;
}

interface IErrorViewProps {
  error: string | ForbiddenException;
  translateMessage?: boolean;
}

const ErrorView = ({ error, translateMessage }: IErrorViewProps): JSX.Element | null => {
  const { i18n } = useTranslation();

  if (!error) {
    return null;
  }
  const errMsg =
    typeof error === 'string' ? (translateMessage ? i18n.t(error as KeyMapKeys) : error) : error.errorMessage;

  return <div className="inline-error">{errMsg}</div>;
};

export default ErrorView;
